import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { FonteEnergia } from '../../components'
import * as fonteEnergiaActionCreators from '../../redux/modules/fonteEnergia'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class FonteEnergiaContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleFonteEnergia: PropTypes.object,
    fetchMultipleFonteEnergia: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyFonteEnergia: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleFonteEnergia()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/fontes_energia/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/fontes_energia/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyFonteEnergia(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('fonteEnergia', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('fonteEnergia', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleFonteEnergia.toList().toJSON(),
      'fonteEnergia',
      ['id', 'nome', 'descricao', 'incentivo'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <FonteEnergia
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleFonteEnergia={this.props.multipleFonteEnergia}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({fonteEnergia, status, sort, filter}) {
  const sortColumn = sort.getIn(['fonteEnergia', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['fonteEnergia', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['fonteEnergia', 'filterText']) || ''

  let map = filterMap(fonteEnergia, ['nome', 'descricao'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleFonteEnergia: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['fonteEnergia', 'error']),
    isLoading: status.getIn(['fonteEnergia', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...fonteEnergiaActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FonteEnergiaContainer)
